<template>
  <section> 
   
    <div class="card-block" v-for="(data, index) in teamData" :key="index">
       <transition>
      <card-template
        :rank = "teamData[index].rank"
        :earning-rate="teamData[index].earningPerSec"
        :annual-profit="teamData[index].annualEarnings"
        :prev-earnings="teamData[index].prevEarnings"
        :prev-rank="teamData[index].prevRank"
        :country="teamData[index].country"
      >
        <template v-slot:image>
          <img
            class="game-logo"
            :src="getImgUrl(teamData[index].image)"
            v-bind:alt="teamData[index].image"
            width="150"
            height="150"
          />
        </template>
        <template v-slot:teamName>
          {{ teamData[index].team }}
        </template>
      </card-template>
      </transition>
    </div>
   
  </section>
</template>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 20px 0px 0px 0px;
}

.card-block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

.game-logo {
  // width: 150px;
  @include respond(phone-only) {
    width: 75px;
    height:75px;
  }
}
.v-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.v-enter-to {
  opacity: 1;
  transform: translateX(0);
}
.v-enter-active {
  transition: all 0.8s ease-out;
}

</style>

<script>
import CardTemplate from "@/components/TeamProfits/CardTemplate";
import data from "@/assets/data/TeamData.js";
export default {
  data() {
    return {
      allData: data.teamData,
      teamData: [],
      // sortType:'',
      // sortDirection:1,
    };
  },
  components: {
    CardTemplate,
  },
  computed: {
    getSearchCat(){

      return this.$store.getters.getSortCat;
    },
    getSearchDir(){
      return this.$store.getters.getSortDirection;
    }
    },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/images/teams/" + pic);
    },
    sortData(){
      let sort=this.$store.getters.getSortCat;
      let direction=this.$store.getters.getSortDirection;
        if (sort == 'country' || sort =="team") {
          this.orderByAlpha(sort, direction);
        } else {
          this.orderByNumber(sort, direction);
        }
    },
    orderByNumber(value, direction) {
    this.teamData = this.teamData.sort(
      (a, b) => (b[value] - a[value]) * direction
    );
  },
  orderByAlpha(value, direction) {
    this.teamData = this.teamData.sort(function (a, b) {
      var nameA = a[value].toUpperCase();
      var nameB = b[value].toUpperCase();
      if (nameA < nameB) {
        return -1 * direction;
      }
      if (nameA > nameB) {
        return 1 * direction;
      }
      return 0;
    });
  },
  },
  watch:{
    getSearchCat: function(){
      this.sortData();
    },
     getSearchDir: function(){
      this.sortData();
    }
  },
  beforeMount() {
    this.teamData = this.allData;
    // this.sortData();
  },
};
</script>